import React from "react";
import logo2 from "../assets/images/logo2.png";

const Logo = () => {
  return (
    <div className="logo h-6 w-6 rounded">
        <img src={logo2} alt="logo" className="rounded" />
    </div>
  );
};

export default Logo;
